import { useEffect } from 'react';
import { Form } from '@ampol/design-system';
import { CardModalFormNames } from './types/CardModalFormNames';
import { ModalSection } from './ModalSection';
import { AUSSIE_STATES, RENEWAL_OPTIONS } from 'utilities/constants';
import SuffixWrapper from 'components/suffix-wrapper/suffix-wrapper';
import DeprecatedIcon from '../../../../assets/svg-icons';
import { useSelectCardModalMeta } from 'selectors/selectors';
import { isWithinDaysBeforeExpiry, isExpiryBeyondFiveYears } from 'utilities/dateUtils';
import { EXPIRY_DAYS_WARNING_THRESHOLD } from '../../../../constants';
import { getCardStatus } from 'utilities/card-utilities';
import { useDisableExpiryDate } from 'selectors/selectors';
import { useDispatchDisableExpiryDate } from 'dispatchers/dispatchers';

export default function CardModalDetails({ isEdit = false }: { isEdit?: boolean }) {
  const meta = useSelectCardModalMeta();

  const isWithinThreshold = isWithinDaysBeforeExpiry(EXPIRY_DAYS_WARNING_THRESHOLD);
  const isStatusCardProcessing = getCardStatus() === 'Processing';
  const isBeyondFiveYearsExipry = isExpiryBeyondFiveYears();
  const disableExpiryDate = useDisableExpiryDate();
  const dispatchDisableExpiryDate = useDispatchDisableExpiryDate();

  useEffect(() => {
    if (isBeyondFiveYearsExipry) {
      dispatchDisableExpiryDate(true);
    }
    return () => {
      dispatchDisableExpiryDate(false);
    };
  }, []);

  return (
    <div className='[&_input]:uppercase'>
      <h3>Card details</h3>
      <ModalSection>
        <Form.Input
          name={CardModalFormNames.EmbossingName}
          label='Embossing name'
          disabled={meta?.disableEmbossingName || (isEdit && (isWithinThreshold || isStatusCardProcessing))}
        />
        <Form.Input
          name={CardModalFormNames.EmbossingLine}
          label='Embossing line 2'
          disabled={isEdit && (isWithinThreshold || isStatusCardProcessing)}
        />
        <Form.Input
          name={CardModalFormNames.VehicleRegistration}
          label='Vehicle registration'
          disabled={isEdit && (isWithinThreshold || isStatusCardProcessing)}
        />
        <Form.Input name={CardModalFormNames.DriverName} label='Driver name' />
      </ModalSection>
      <ModalSection>
        <Form.Input
          name={CardModalFormNames.IssueDateFrom}
          label='Issue date from'
          disabled
          placeholder='dd/mm/yyyy'
          inputSuffix={
            <SuffixWrapper>
              <DeprecatedIcon iconName='calender' />
            </SuffixWrapper>
          }
        />
        <Form.DatePicker
          name={CardModalFormNames.IssueDateTo}
          label='Expiry Date (MM/YY)'
          placeholder={'MM/YY'}
          format={'MM/YY'}
          picker={'month'}
          inputSuffix={
            <SuffixWrapper>
              <DeprecatedIcon iconName='calender' />
            </SuffixWrapper>
          }
          disabled={isEdit && (isStatusCardProcessing || (disableExpiryDate && isBeyondFiveYearsExipry))}
        />
        <Form.DropdownSearch
          label={'Renewal option'}
          name={CardModalFormNames.RenewalOption}
          data={RENEWAL_OPTIONS}
          placeholder={'Select renewal option'}
        />
        <Form.Input name={CardModalFormNames.CostCentreCode} label='Cost centre code' />
      </ModalSection>
      <ModalSection last>
        <Form.Input name={CardModalFormNames.DomesticNumber} label='Domestic number' />
        <Form.DropdownSearch
          label={'Registration state'}
          name={CardModalFormNames.RegistrationState}
          data={AUSSIE_STATES}
          placeholder={'Select registration state'}
        />
        <Form.Input name={CardModalFormNames.VehicleDescription} label='Vehicle description' />
      </ModalSection>
    </div>
  );
}
